import React from 'react';
const buildPages = (current, total) => {
  const delta = 2;
  const pages = [];
  let prev = null;
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || i >= current - delta && i <= current + delta) {
      if (prev !== null && i - prev > 1) pages.push('...');
      pages.push(i);
      prev = i;
    }
  }
  return pages;
};
const base = {
  minWidth: 36,
  height: 36,
  padding: '0 10px',
  borderRadius: 8,
  border: '1px solid #e2e8f0',
  background: '#ffffff',
  color: '#475569',
  fontSize: '0.875rem',
  fontWeight: 500,
  cursor: 'pointer',
  lineHeight: 1,
  transition: 'background 0.15s, color 0.15s, border-color 0.15s'
};
const currentStyle = {
  ...base,
  background: '#1b1a21ff',
  borderColor: '#1b1a21ff',
  color: '#ffffff',
  fontWeight: 700,
  cursor: 'default',
  opacity: 1
};
const disabledStyle = {
  ...base,
  cursor: 'default',
  opacity: 0.4
};
const endStyle = {
  ...base,
  fontSize: '1.2rem',
  fontWeight: 400
};
const Pagination = ({
  limit,
  total,
  offset,
  onClick
}) => {
  const totalPages = Math.ceil(total / limit);
  if (totalPages <= 1) return null;
  const current = Math.floor(offset / limit) + 1;
  const pages = buildPages(current, totalPages);
  const go = page => onClick(null, (page - 1) * limit);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
      padding: '16px 0',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement("button", {
    style: current <= 1 ? disabledStyle : endStyle,
    disabled: current <= 1,
    onClick: () => go(current - 1)
  }, "\u2039"), pages.map((p, i) => p === '...' ? /*#__PURE__*/React.createElement("span", {
    key: `e${i}`,
    style: {
      minWidth: 36,
      height: 36,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#94a3b8',
      fontSize: '0.875rem',
      userSelect: 'none'
    }
  }, "\u2026") : /*#__PURE__*/React.createElement("button", {
    key: p,
    style: p === current ? currentStyle : base,
    disabled: p === current,
    onClick: () => go(p)
  }, p)), /*#__PURE__*/React.createElement("button", {
    style: current >= totalPages ? disabledStyle : endStyle,
    disabled: current >= totalPages,
    onClick: () => go(current + 1)
  }, "\u203A"));
};
export default Pagination;